export const ROUTING = {
  HOMEPAGE: "/",
  LOGIN: "/login",
  SIGNUP: "/signup",
  BOOK_DOCTOR: "/book-doctor",
  BOOK_LAB: "/book-lab",
  INSURE_KARO: "/insure-karo",
  INSURANCE: "/insure-karo/insurance",
  SEHAT_CARD: "/insure-karo/sehat-card",
  DIGITAL_ROSHAN: "/insure-karo/digital-roshan",
  PHARMACY: "/pharmacy",
  BUYINGFOR: "/pharmacy/buying-for",
  OURPRODUCTS: "/pharmacy/our-products",
  BESTSELLER: "/pharmacy/best-sellers",
  FREQUENTLY_BOUGHT: "/pharmacy/frequently-bought",
  OUR_CATEGORIES: "/pharmacy/our_categories",
  BRANDS: "/pharmacy/brands",
  PRODUCT_ITEM: "/pharmacy/product-item",
  CART: "/pharmacy/cart",
  CHECKOUT: "/pharmacy/checkout",
  CONTACT: "/contact-us",
  THANKYOU: "/thank-you",
  ABOUTUS: "/about-us",
  PROFILE: "/profile",
  MYPROFILE: "/profile/my-profile",
  PRESCIPTION: "/profile/presciption",
  BENEFICIARY: "/profile/beneficiary",
  UPDATE_BENEFICIARY: "/profile/beneficiary/update",
  ORDERS: "/profile/orders",
  REPORT: "/profile/report",
  MY_INSURANCE: "/profile/my-insurance",
  BILLING: "/profile/billing",
  PAYMENT: "/profile/payment",
  LOGOUT: "/profile/logout",
  PRIVACY_POLICY: "/privacy-policy",
  SHIPPING_POLICY: "/shipping-policy",
  TERMS_OF_USE: "/terms-of-use",
  BLOGS: "/blogs",
  RETURN_POLICY: "/return-policy",
  FAQS: "/faqs",
  CHANGE_PASSWORD: "/change-password",
  PASSWORD: "/profile/update-password",
  FORGET_PASSWORD: "/login/forget-password",
  LAB_BOOKING: "/details",
  DOCTOR_BOOKING: "/booking-details",
  VIDEO_CONFERENCE: "/video-conference",
  Pharm_Detail: "/pharmacy-order-details",
  VERIFY_ACCOUNT: "/verify-account",
  DELETE_ACCOUNT: "/delete-account",
  CONFIRM_DELETE_ACCOUNT: "/confirm-delete-account",
};
